import { callAPI } from '@alphapoint/apex-web/lib/redux/actions/apiActions';
import {
  fetchingDepositInfo,
  receiveDepositInfo,
  depositInfoError,
} from '@alphapoint/apex-web/lib/redux/actions/depositActions';

export const getDepositInfoWithOptions =
  (productId, { accountProviderId, generateNewKey = false } = {}) =>
  async (dispatch, getState) => {
    const state = getState();
    const { OMSId } = state.user.userInfo;
    const AccountId = state.user.selectedAccountId;

    const payload = {
      OMSId,
      AccountId,
      ProductId: +productId,
      GenerateNewKey: generateNewKey,
    };

    if (accountProviderId) {
      payload.AccountProviderId = accountProviderId;
    } else {
      const templateType = state.deposit.AccountProviderId;
      const templateTypeObj = state.deposit.templateTypes.find(
        (template) => template.AccountProviderId === templateType,
      );
      if (templateTypeObj) {
        payload.AccountProviderId = templateTypeObj.AccountProviderId;
      }
    }

    dispatch(fetchingDepositInfo(productId));
    const response = await dispatch(callAPI('GetDepositInfo', payload));

    if (!response.result) {
      return dispatch(depositInfoError(response.errormsg));
    }

    let data;
    try {
      data = JSON.parse(response.DepositInfo);
    } catch (e) {
      data = [response.DepositInfo];
    }
    return dispatch(receiveDepositInfo(data));
  };
